import React, { useCallback, useEffect, useState } from 'react';
import useMouseActivityDetector from '../../hooks/useMouseActivityDetector';
import { MOUSE_ACTIVITY_DETECTION } from '../../consts';
import ConfirmModal from '../ConfirmModal';
import strings from '../../strings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import './index.scss';
import { SignOutPath } from '../../routing';
import { useAuth } from 'oidc-react';

const MouseActivityDetector = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [timer, setTimer] = useState(0);
  const [isUrgent, setIsUrgent] = useState(false);
  const history = useHistory();
  const auth = useAuth();
  const timeout =
    MOUSE_ACTIVITY_DETECTION.INACTIVITY + MOUSE_ACTIVITY_DETECTION.WARING_TIME;
  const { countdown, resetActivityTimer } = useMouseActivityDetector(timeout);

  const handleLogout = useCallback(() => {
    setShowPopup(false);
    history.push(SignOutPath);
  }, [history]);

  useEffect(() => {
    if (countdown <= MOUSE_ACTIVITY_DETECTION.LOGOUT_TIME) {
      handleLogout();
      return;
    }

    if (auth.userData == null) {
      return;
    }

    if (countdown <= MOUSE_ACTIVITY_DETECTION.WARING_TIME) {
      setShowPopup(true);
      setTimer(countdown);
    } else {
      setShowPopup(false);
    }

    if (countdown < MOUSE_ACTIVITY_DETECTION.URGENT_TIME) {
      setIsUrgent(true);
    } else {
      setIsUrgent(false);
    }
  }, [countdown, auth.userData, handleLogout]);

  const onContinue = useCallback(() => {
    setShowPopup(false);
    resetActivityTimer();
  }, [resetActivityTimer]);

  const renderTimer = () => {
    const formatNumber = (num: number) => (num < 10 ? `0${num}` : num);
    const minutes = formatNumber(Math.floor(timer / 60000));
    const seconds = formatNumber(Math.floor((timer % 60000) / 1000));
    return (
      <div
        className={classNames('countdown-timer text-center', {
          urgent: isUrgent
        })}>
        {`${minutes}:${seconds}`}
      </div>
    );
  };

  return (
    <div>
      <ConfirmModal
        content={strings.mouseActivityDes}
        headerIcon={
          <FontAwesomeIcon
            icon={faTriangleExclamation as IconProp}
            fontSize={24}
          />
        }
        header={strings.inactivityWarning}
        secondContent={renderTimer()}
        cancelButton={strings.componentHeaderLogoutButton}
        confirmButton={strings.componentContinueButton}
        onCancel={handleLogout}
        onConfirm={onContinue}
        show={showPopup}
        bodyClassName="mouse-activity-modal"
      />
    </div>
  );
};

export default MouseActivityDetector;
